// extracted by mini-css-extract-plugin
export var active = "bD_bd";
export var categories = "bD_cJ";
export var category = "bD_cK";
export var icon = "bD_bv";
export var icons = "bD_by";
export var image = "bD_g";
export var member = "bD_gL";
export var memberTitle = "bD_gM";
export var name = "bD_fB";
export var placeholder = "bD_bb";
export var section = "bD_d";
export var show = "bD_L";
export var subtitle = "bD_cV";
export var team = "bD_gK";